export enum RouteTitle {
  PASSWORD = 'password:changePassword:title',
  EMPLOYEES = 'employees:employees.title',
  ORGANIZATION_DETAILS = 'organizationDetails:title',
  AUDIT_LOGS = 'auditLogs:common.route',
  SPACES = 'spaces:common.title',
  BOOKING_RULES = 'bookingRules:common.title',
  BOOKINGS = 'bookings:common.title',
  ISSUES = 'issues:common.title',
  STATISTICS = 'statistics:common.title',
  CALENDAR_INTEGRATION = 'calendarIntegration:title',
}

export enum SidebarRouteTitle {
  SETUP = 'routes:setup',
  DATA_AND_ISSUES = 'routes:dataAndIssues',
  SUPPORT_AND_SETTINGS = 'routes:supportAndSettings',
}

export enum SubRouteTitle {}
